import { Component, input, OnInit, output } from '@angular/core';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { FormDataService, FormSchemaComponent } from '@mds/ui';
import { Row } from '@pages/mattermaps/components/layers/components/costing-grid-wrapper/costing-grid-wrapper.model';
import { MakersiteService } from '@services/makersite.service';

@Component({
  selector: 'app-cost-model-dialog-body',
  templateUrl: './cost-model-dialog-body.component.html',
  styleUrls: ['./cost-model-dialog-body.component.scss'],
  imports: [FormSchemaComponent],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'options-container' }
    },
    {
      provide: FormDataService,
      useFactory: (svc: MakersiteService) => new FormDataService(svc),
      deps: [MakersiteService]
    }
  ]
})
export class CostModelDialogBodyComponent implements OnInit {
  data = input<any>();
  formValuesChange = output<any>();

  schema: any;
  rowData: Row;
  previousType: string;

  constructor(private makersiteService: MakersiteService) {}

  ngOnInit(): void {
    const inputData = this.data();

    if (!inputData) {
      return;
    }

    this.rowData = inputData.rowData;
    this.schema = {
      lines: this.getLines(),
      formSchema: inputData.formSchema
    };
  }

  getLines() {
    const lineArray = [];
    let costModel = this.rowData.cost_model;
    costModel = Object.keys(costModel).map((key) => costModel[key]);

    if (this.rowData?.raw?.process_type) {
      lineArray.push(this.rowData?.raw?.process_type);
    }

    costModel.forEach((element) => {
      if (element && Array.isArray(element)) {
        element.forEach((f) => {
          lineArray.push(f);
        });
      } else {
        lineArray.push(element);
      }
    });

    return lineArray;
  }

  onFormValueChanged(event) {
    const type = event?.value['Costing Options'].process_type;

    this.formValuesChange.emit(event);

    if (type && type !== this.previousType) {
      this.previousType = type;
      this.getAdditionalScheme(type);
    }
  }

  getAdditionalScheme(type) {
    this.makersiteService.costModelProcessData(this.rowData.rid, type).subscribe((res: any) => {
      const node = this.schema.formSchema.find((fs) => fs.name === 'Costing');

      if (node) {
        node.formSchema = this.data().allFormSchema[type];
      } else {
        this.schema.formSchema = this.schema.formSchema.concat({
          name: 'Costing',
          formSchema: this.data().allFormSchema[type],
          lines: null
        });
      }

      this.schema.lines = this.schema.lines.concat(res);
    });
  }
}
